export enum ConnectorMessageType {
  EMPTY_MESSAGE = 'EMPTY_MESSAGE',
  SAVE_MESSAGE = 'SAVE_MESSAGE',
  ENTER_DESIGN = 'ENTER_DESIGN',
  LEAVE_DESIGN = 'LEAVE_DESIGN',
  RESET_DESIGN = 'RESET_DESIGN',
  ADD_CARD = 'ADD_CARD',
  MOVE_CARD = 'MOVE_CARD',
  DELETE_CARD = 'DELETE_CARD',
  ENTER_CARD_LINK = 'ENTER_CARD_LINK',
  LEAVE_CARD_LINK = 'LEAVE_CARD_LINK',
  ADD_LINK = 'ADD_LINK',
  DELETE_LINK = 'DELETE_LINK',
  ENTER_CARD_NOTE = 'ENTER_CARD_NOTE',
  LEAVE_CARD_NOTE = 'LEAVE_CARD_NOTE',
  ADD_CARD_NOTE = 'ADD_CARD_NOTE',
  CHANGE_CARD_NOTE = 'CHANGE_CARD_NOTE',
  DELETE_CARD_NOTE = 'DELETE_CARD_NOTE',
  ENTER_LINK_NOTE = 'ENTER_LINK_NOTE',
  LEAVE_LINK_NOTE = 'LEAVE_LINK_NOTE',
  ADD_LINK_NOTE = 'ADD_LINK_NOTE',
  CHANGE_LINK_NOTE = 'CHANGE_LINK_NOTE',
  DELETE_LINK_NOTE = 'DELETE_LINK_NOTE',
  HEARTBEAT_LOCK = 'HEARTBEAT_LOCK'
}
